import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckSquare } from 'lucide-react';
import { SectionWrapper } from './ui/SectionWrapper';
export function ContentPreview() {
  return <SectionWrapper background="slate" data-id="element-61">
      <div className="text-center mb-12" data-id="element-62">
        <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-63">
          Muestra del contenido
        </h2>
        <p className="text-lg text-slate-600" data-id="element-64">
          Así de práctico y directo es el ebook
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-65">
        {/* Item 1: P&L Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-66">
          <h3 className="font-bold text-slate-900 mb-4 text-center" data-id="element-67">
            Ejemplo: P&L por unidad
          </h3>
          <div className="overflow-hidden rounded-lg border border-slate-100" data-id="element-68">
            <table className="w-full text-sm" data-id="element-69">
              <thead className="bg-slate-50" data-id="element-70">
                <tr data-id="element-71">
                  <th className="px-4 py-2 text-left text-slate-500 font-medium" data-id="element-72">
                    Concepto
                  </th>
                  <th className="px-4 py-2 text-right text-slate-500 font-medium" data-id="element-73">
                    Monto
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-74">
                <tr data-id="element-75">
                  <td className="px-4 py-2 text-slate-700" data-id="element-76">Precio de venta</td>
                  <td className="px-4 py-2 text-right text-slate-900 font-medium" data-id="element-77">
                    $24.99
                  </td>
                </tr>
                <tr data-id="element-78">
                  <td className="px-4 py-2 text-slate-500" data-id="element-79">Costo (COGS)</td>
                  <td className="px-4 py-2 text-right text-red-500" data-id="element-80">-$6.00</td>
                </tr>
                <tr data-id="element-81">
                  <td className="px-4 py-2 text-slate-500" data-id="element-82">Envío a Amazon</td>
                  <td className="px-4 py-2 text-right text-red-500" data-id="element-83">-$1.50</td>
                </tr>
                <tr data-id="element-84">
                  <td className="px-4 py-2 text-slate-500" data-id="element-85">
                    Referral Fee (15%)
                  </td>
                  <td className="px-4 py-2 text-right text-red-500" data-id="element-86">-$3.75</td>
                </tr>
                <tr data-id="element-87">
                  <td className="px-4 py-2 text-slate-500" data-id="element-88">FBA Fee</td>
                  <td className="px-4 py-2 text-right text-red-500" data-id="element-89">-$3.50</td>
                </tr>
                <tr data-id="element-90">
                  <td className="px-4 py-2 text-slate-500" data-id="element-91">Ads (estimado)</td>
                  <td className="px-4 py-2 text-right text-red-500" data-id="element-92">-$2.00</td>
                </tr>
                <tr className="bg-emerald-50" data-id="element-93">
                  <td className="px-4 py-3 font-bold text-emerald-800" data-id="element-94">
                    Margen neto
                  </td>
                  <td className="px-4 py-3 text-right font-bold text-emerald-700" data-id="element-95">
                    $8.24
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-[10px] text-slate-400 mt-3 italic text-center" data-id="element-96">
            *Ejemplo ilustrativo. Los números reales varían.
          </p>
        </motion.div>

        {/* Item 2: Checklist */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-97">
          <h3 className="font-bold text-slate-900 mb-4 text-center" data-id="element-98">
            Checklist: Validar producto
          </h3>
          <ul className="space-y-3" data-id="element-99">
            {['Demanda mínima: 300+ ventas/mes', 'Competencia: <5 listings con 1000+ reviews', 'Precio de venta entre $15 y $50', 'Margen neto estimado > 25%', 'Producto no frágil, liviano, sin restricciones', 'Posibilidad de diferenciación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-slate-600" data-id="element-100">
                <CheckSquare className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-101" />
                <span data-id="element-102">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Item 3: Common Error */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-red-50 border border-red-100 p-6 rounded-xl flex flex-col justify-center" data-id="element-103">
          <div className="flex items-center gap-2 text-red-600 font-bold mb-3" data-id="element-104">
            <AlertTriangle className="h-5 w-5" data-id="element-105" />
            <h3 data-id="element-106">Error común</h3>
          </div>
          <p className="text-sm text-red-900/80 mb-4 leading-relaxed" data-id="element-107">
            Muchos principiantes eligen su primer producto basándose solo en el
            margen, sin evaluar la competencia ni la velocidad de venta.
            Resultado: inventario estancado y tarifas de almacenamiento que se
            comen las ganancias.
          </p>
          <div className="bg-white/50 p-3 rounded-lg border border-red-200" data-id="element-108">
            <p className="text-xs text-red-800 font-medium" data-id="element-109">
              💡 Siempre calcula tu break-even point ANTES de hacer el primer
              pedido.
            </p>
          </div>
        </motion.div>
      </div>
    </SectionWrapper>;
}